import React, {Component} from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import {Card, Button} from 'antd';
import {getUsers} from './actions';
import {bindActionCreators} from "redux";
import {Link} from 'react-router-dom';
import permissions from './permissions';
import ResponsiveTable from "../common/ResponsiveTable";

const usersColumns = [
  {
    title: 'Username',
    dataIndex: 'username',
    key: 'username'
  },
  {
    title: 'Permissions',
    dataIndex: 'permissions',
    key: 'permissions',
    render: x => x.map(v => (permissions.findByValue(v) || {text: 'N/A'}).text).join(', ')
  },
  {
    title: 'Action',
    key: 'action',
    render: (_, {userId}) => <span>
      <Link to={`/user/update/${encodeURIComponent(userId)}`}>Edit</Link>
    </span>
  }
];

class UsersPage extends Component {
  componentDidMount() {
    this._load();
  }

  _load = (newPagination) => {
    const {pagination} = this.props;
    this.props.getUsers({pagination: newPagination || pagination});
  };

  handleAdd = e => {
    e.preventDefault();
    this.props.history.push('/user/add');
  };

  render() {
    const {users, loading, pagination} = this.props;
    return (
      <Card title="Users" extra={<Button type="primary" icon="plus" onClick={this.handleAdd}>Add</Button>}>
        <ResponsiveTable
          loading={loading}
          columns={usersColumns}
          dataSource={users}
          rowKey="userId"
          pagination={pagination}
          onChange={this._load}
        />
      </Card>
    );
  }
}

UsersPage.propTypes = {
  loading: PropTypes.bool.isRequired,
  history: PropTypes.object.isRequired,
  users: PropTypes.array.isRequired,
  pagination: PropTypes.object.isRequired,
  /* actions */
  getUsers: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  loading: state.user.usersLoading,
  users: state.user.users,
  pagination: state.user.usersPagination,
});

const mapDispatchToProps = dispatch => ({
  getUsers: bindActionCreators(getUsers, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(UsersPage);



// WEBPACK FOOTER //
// ./src/User/UsersPage.js